export type PaginationItem = number | 'start-gap' | 'end-gap';

export function normalizePagination(currentPage: number, totalPages: number) {
  const total = Number.isSafeInteger(totalPages) ? Math.max(0, totalPages) : 0;
  const current = Number.isSafeInteger(currentPage) ? currentPage : 1;
  return { totalPages: total, currentPage: Math.max(1, Math.min(current, total || 1)) };
}

/** At most seven slots, regardless of result size; endpoints and current page are always kept. */
export function getPaginationItems(currentPage: number, totalPages: number): PaginationItem[] {
  const { currentPage: current, totalPages: total } = normalizePagination(currentPage, totalPages);
  if (total <= 7) return Array.from({ length: total }, (_, index) => index + 1);

  const start = current <= 4 ? 2 : current >= total - 3 ? total - 4 : current - 1;
  const end = current <= 4 ? 5 : current >= total - 3 ? total - 1 : current + 1;
  const items: PaginationItem[] = [1];
  if (start > 2) items.push('start-gap');
  for (let page = start; page <= end; page += 1) items.push(page);
  if (end < total - 1) items.push('end-gap');
  items.push(total);
  return items;
}
